import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { GetInventoryItemsByOperatingUnitId } from '@store/INV/MasterItems/MasterItemsSlice';
import { useTranslation } from 'react-i18next';

const useGetInventoryItemsByOperatingUnitId = ({ OperatingUnitId }: { OperatingUnitId: string }) => {
  const dispatch = useAppDispatch();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (OperatingUnitId) {
      dispatch(GetInventoryItemsByOperatingUnitId(OperatingUnitId));
    }
  }, [OperatingUnitId, dispatch]);

  const {
    InventoryItemsByOperatingUnitId,
    InventoryItemsByOperatingUnitIdLoading: loading,
    InventoryItemsByOperatingUnitIdError: error
  } = useAppSelector(state => state.MasterItemsINV);

  // console.log(console.log(JSON.stringify(InventoryItemsByOperatingUnitId)));

  const InventoriesByOperatingUnitId = InventoryItemsByOperatingUnitId.map(m => ({
    label: i18n.language === 'en' ? m.inventoryName : m.inventoryName2,
    value: m.inventoryId
  })) 

  return { loading, error, InventoryItemsByOperatingUnitId, InventoriesByOperatingUnitId };
};

export default useGetInventoryItemsByOperatingUnitId;
